<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      :class="{ paddingBottom: footer }"
      maxwidth-container="820px"
    >
      <v-breadcrumbs
        v-if="$vuetify.breakpoint.mdAndUp"
        :items="menus"
        class="pl-0 mt-6"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled"
            class="body-2"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <TituloPagina :titulo="tituloPagina" class="mt-7 mt-md-4" />

      <div
        v-if="loading"
        class="pt-5"
      >
        <template v-for="index in 6">
          <v-skeleton-loader
            :key="`item-${index}`"
            class="mx-auto my-5"
            type="text"
          />
        </template>
      </div>

      <ListaMotivos
        v-else
        :lista="listaMotivos"
        mostrar-outros
        class="mt-md-5 mb-md-10"
      />
      <BtnVoltar
        v-if="$vuetify.breakpoint.smAndDown"
        :voltar-para="urlVoltar"
        max-width="800px"
      />

      <v-btn
        v-if="$vuetify.breakpoint.mdAndUp && !loading"
        class="mt-10"
        color="primary"
        data-cy="btn_voltar"
        outlined
        width="278"
        @click="$router.go(-1)"
      >
        Voltar
      </v-btn>
    </InternaMain>
  </Wrapper>
</template>

<script>
import api from '@/api';
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ListaMotivos from '@/components/NaoEncontrei/ListaMotivos.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Motivos',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    BtnVoltar,
    TituloPagina,
    ListaMotivos,
  },

  data() {
    return {
      loading: true,
      tituloPagina: 'Preciso de ajuda com a minha compra',
      listaMotivos: [],
      urlApi: '/refund-request/open/categories',
      footer: true,
      motivos: [],
      menus: [
        {
          text: 'Minhas Compras',
          disabled: false,
          href: '/minhas-compras/',
        },
        {
          text: 'Ajuda - Solicitar reembolso',
          disabled: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),
    checkFilterProductType() {
      const possuiDigital = this.dadosCompra.possuiProdutoDigital;
      const possuiFisico = this.dadosCompra.possuiProdutoFisico;

      if (possuiDigital && !possuiFisico) {
        return `${this.urlApi}/digital`;
      }

      if (possuiFisico && !possuiDigital) {
        return `${this.urlApi}/physical`;
      }

      return this.urlApi;
    },
  },

  created() {
    this.carregarListaMotivos();
  },

  methods: {
    async carregarListaMotivos() {
      try {
        const { data } = await api.get(this.checkFilterProductType);
        this.motivos = data;
        this.$store.dispatch('setMotivosReembolso', this.motivos.slice(5));
        this.listaMotivos = this.motivos.slice(0, 5);
      } catch (error) {
        this.motivos = [];
      }
      this.loading = false;
    },
  },


};
</script>

<style lang="scss">
  .paddingBottom{
    padding-bottom: 0!important
  }
</style>
